export default "__VITE_ASSET__DXa1V6Ro__";